import { PageWrapper } from '../../components/PageWrapper';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import OtpInput from 'react18-input-otp';
import {
  PHONE_PASSWORD_LOGIN,
  PHONE_PASSWORD_CREATE,
} from '../../constants/routes';
import { handleOtpVerification, formatPhoneNumber } from '../../utils/phoneNumber';
import { auth } from '../../firebase/firebaseConfig';
import { phoneNumberSignUp } from '../../pages/account/phoneNumberLogin/services/phoneAuthService';
import { notifySuccess } from '../../utils/Notify';
import { BeatLoader } from 'react-spinners';
export const PhoneNumberVerify = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { phoneNumber, userExists } = location.state || {};
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [resending, setResending] = useState(false);

  useEffect(() => {
    if (!phoneNumber || userExists) {
      navigate(PHONE_PASSWORD_LOGIN);
    }
  }, [phoneNumber, userExists, navigate]);

  useEffect(() => {
    if (!window.confirmationResult) {
      setError('Session expirée. Veuillez recommencer.');
      setTimeout(() => {
        navigate(PHONE_PASSWORD_LOGIN);
      }, 2000);
    }
  }, [navigate]);

  const displayNumber = phoneNumber ? formatPhoneNumber(phoneNumber) : '';

  const handleVerifyCode = async (otp) => {
    if (otp.length !== 6) return;

    setError('');

    const result = await handleOtpVerification({
      auth,
      otp,
      setLoading,
      onSuccess: () => {
        navigate(PHONE_PASSWORD_CREATE, {
          state: {
            phoneNumber,
            isForgotPassword: false,
            isVerified: true,
            isNewUser: true,
          },
        });
      },
      onError: (errorMessage) => {
        if (errorMessage?.includes('code-expired')) {
          setError('Code expiré. Veuillez demander un nouveau code.');
          setTimeout(() => navigate(PHONE_PASSWORD_LOGIN), 3000);
        } else if (errorMessage?.includes('invalid-verification-code')) {
          setError('Code incorrect. Veuillez réessayer.');
        } else {
          setError('Erreur de vérification. Veuillez réessayer.');
        }
        setCode('');
      },
    });

    if (!result.success) {
      setCode('');
    }
  };

  useEffect(() => {
    if (code.length === 6) {
      handleVerifyCode(code);
    }
  }, [code]);

  const handleResendSMS = async () => {
    if (!phoneNumber || resending) return;

    setResending(true);
    setError('');
    setCode('');

    try {
      const result = await phoneNumberSignUp(
        auth,
        phoneNumber,
        null,
        'signup',
        'phone-verify-resend-recaptcha',
        setResending
      );

      if (result?.success) {
        notifySuccess('Code renvoyé avec succès');
        setResending(false);
      } else {
        setError('Erreur lors du renvoi du code. Veuillez réessayer.');
        setResending(false);
      }
    } catch (error) {
      console.error('Resend SMS error:', error);
      setError('Erreur lors du renvoi du code. Veuillez réessayer.');
      setResending(false);
    }
  };

  return (
    <PageWrapper
      title="👀 Code envoyé par SMS"
      onGoBack={() => navigate(PHONE_PASSWORD_LOGIN, { state: { phoneNumber } })}
    >
      <div className="flex flex-col items-center justify-center gap-4">
        <p className="text-start w-full text-xl text-gray-800 geomanistRegular mb-6">
          Envoyé au <span className="geomanistMedium">{displayNumber}</span>
        </p>

        {loading ? (
          <BeatLoader color="#183153" size={20} />
        ) : (
          <OtpInput
          value={code}
          onChange={setCode}
          numInputs={6}
          isInputNum={true}
          isDisabled={loading}
          shouldAutoFocus={true}
          inputStyle="password-input"
          isInputSecure={false}
          inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
          separator={<span className="otp-separator" />}
          containerStyle="otp-container"
        />
        )}

        {error && (
          <div className="bg-red-50 border border-red-200 rounded-lg p-4 mt-4 w-full">
            <p className="text-red-600 text-lg font-semibold text-center">{error}</p>
          </div>
        )}

        {!loading && !error && (
          <p className="text-gray-500 text-xl mt-4 text-center">
            Le code expire dans quelques minutes
          </p>
        )}

        <button
          type="button"
          className="geomanistMedium mt-6 text-xl p-4 underline rounded-full w-full disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={handleResendSMS}
          disabled={resending || loading}
        >
          {resending ? 'Envoi en cours...' : 'Renvoyer le SMS'}
        </button>
      </div>
      {/* Hidden reCAPTCHA container for resend */}
      <div id="phone-verify-resend-recaptcha" style={{ display: 'none' }} />
    </PageWrapper>
  );
};

